import { Close } from "@mui/icons-material";
import { Box, Button, IconButton, Modal, TextField, Typography, useMediaQuery } from "@mui/material"
import { useState } from "react";

const CloseoutModal = ({ open, handleClose, title, onSubmit }) => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const isLaptop = useMediaQuery('(max-width:1280px)')
    const [titleData, setTitleData] = useState("")

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: isMobile ? '85vw' : isLaptop ? '60vw' : '35vw',
        maxHeight: 650,
        overflow: "hidden",
        bgcolor: 'background.paper',
        boxShadow: 24,
        borderRadius: 2,
        display: 'flex',
        flexDirection: 'column',
    };
    const headerFooterStyle = {
        position: 'sticky',
        zIndex: 1,
        backgroundColor: 'background.paper',
    };    

    const handleChange = (e) => {
        setTitleData(e.target.value)
    }

    const handleModalClose = () => {
        handleClose();
    };    

    const handleFormSubmit = (e) => {
        e.preventDefault();
        onSubmit({title: titleData})
        setTitleData("")
    };    

    return (
        <Modal open={open} onClose={handleModalClose}>
            <form onSubmit={handleFormSubmit}>
                <Box sx={modalStyle}>
                    <Box
                        sx={{
                            ...headerFooterStyle,
                            top: 0,
                            p: 2,
                            borderBottom: '1px solid #ccc',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <Typography variant="h6">{title}</Typography>
                        <IconButton onClick={handleClose} size="small">
                            <Close />
                        </IconButton>
                    </Box>                    

                    <Box sx={{ overflowY: 'auto', flexGrow: 1, p: 2 }}>
                        <div>
                            <TextField
                                required={true}
                                type={"text"}
                                name={"title"}
                                label={"Title"}
                                value={titleData}
                                onChange={handleChange}
                                variant="outlined"
                                fullWidth
                                margin="normal"
                            />                        
                        </div>
                    </Box>
                    <Box sx={{ ...headerFooterStyle, bottom: 0, p: 2, borderTop: '1px solid #ccc', display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Button type="submit" variant="contained" color="primary" sx={{ marginTop: "1em" }}>
                            Submit
                        </Button>
                    </Box>       
                </Box>                         
            </form>
        </Modal>
    )
}

export default CloseoutModal